
export class CountryAndRegionComponent {

    private $root:JQuery;
    private $countries:JQuery;
    private $regions:JQuery;

    // @ts-ignore
    constructor(elem:HTMLElement) {
        this.$root = $(elem);
        this.$countries = this.$root.find('.js-countries-and-regions__countries');
        this.$regions = this.$root.find('.js-countries-and-regions__regions');
        this.bindUI();
    }

    /**
     * Sets up fancy box for this gallery. Sets up filter functionality.
     */
    private bindUI() {
        this.$root.on('update', this.handleUpdate);
        this.$countries.on({ change: this.handleChange });
        if (null === this.$countries.val() || '' === this.$countries.val()) {
            this.$regions.hide();
        }
    }

    private reset = () => {
        this.$countries.val(null);
        this.$regions.hide();
    };

    private handleUpdate = (ev:any, values:any) => {
        if (values.country) {
            this.$countries.val(values.country);
            this.$root.on('regions.loaded', () => {
                this.$regions.val(values.region);
            });
            this.$countries.trigger('change');
        } else {
            this.reset();
        }
    };

    private handleChange = (ev:any) => {
        this.$regions.attr('disabled', 'disabled');
        if (null !== this.$countries.val() && '' !== this.$countries.val()) {
            $.getJSON('/ajax/get-region-data', {iata: this.$countries.val()}, (json:any) => {
                this.$regions.find('option').remove();
                // @ts-ignore
                if (Object.keys(json).length == 0) {
                    this.$regions.val('');
                    this.$regions.hide();
                    return;
                }
                this.$regions.append('<option value="">Select your region</option>');
                for (var i in json) {
                    if (json.hasOwnProperty(i)) {
                        this.$regions.append('<option value="' + i + '">' + json[i] + '</option>');
                    }
                }
                this.$regions.removeAttr('disabled');
                this.$regions.show();
                this.$root.trigger('regions.loaded');
            });
        }
    }
}